// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"703":"5e616696","787":"af397e44","820":"1ce05265"}[chunkId] + ".chunk.js";
};